/**
 * `item_id` — the item's own id, read-only and copyable.
 *
 * Captured: a 185 × 48 white card, radius 3, 16px/400 (`editors/item_id/capture.json`), which
 * is the copy affordance rather than an editor — the type is *"read-only, auto-calculated …
 * does not support update, clear, or set-on-creation"* `[09§A.7 item_id]`.
 */
import { getColumnType, itemIdDisplay, type ItemIdSettings, type ItemIdValue } from '@elizmonday/shared';
import { defineColumnUi } from '../types';
import { ItemIdSettingsDialog } from './SettingsDialog';

const shared = getColumnType('item_id');

export const itemIdColumnUi = defineColumnUi<ItemIdValue, ItemIdSettings>({
  type: 'item_id',
  icon: 'columnGeneric',
  gallery: { group: 'advanced', keywords: ['item id', 'id', 'key', 'reference'] },
  /** P-022: the registry default. ASSUMED — no `width: null` column of this type is measured. */
  defaultWidth: 140,
  align: 'left',
  groupable: false,

  Cell: ({ value, settings, item }) => {
    // The cell is projected on read; the grid's fixture may not carry a value at all.
    const text = itemIdDisplay(value ?? { item_id: String(item.id) }, settings);
    return (
      <span className="ez-cell__text" data-align="left" title={text}>
        {text}
      </span>
    );
  },

  SettingsDialog: ItemIdSettingsDialog,

  fromClipboard() {
    throw new Error('the item id column is read-only');
  },
  toClipboard(value, settings) {
    return shared.toText(value, settings) ?? '';
  },
  bucketsOf() {
    return [];
  },
});
